<template>
    <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
        <div style="padding:0px;width:100%;">
            <!-- <div class="whiteBox dashboard_topic" >
                <div class="portlet-title">
                    <i class="el-icon-d-arrow-right">&nbsp;</i>趋势分析
                </div>
                <div class="portlet-content" v-loading="chartLoading">
                    <div id="chart"></div>
                </div>
            </div> -->

            <div class="whiteBox dashboard_topic">
                <div class="portlet-title">
                    <i class="el-icon-d-arrow-right">&nbsp;</i>线下客户统计
                </div>
                <div class="portlet-content">
                    <div class="filter-container" style="padding-top: 0px;">
                        <el-radio-group class="filter-item" size="mini" v-model="listQuery.dateType" @change="listQuery.searchDate = new Date();">
                            <el-radio-button :label="1">按日</el-radio-button>
                            <el-radio-button :label="2">按周</el-radio-button>
                            <el-radio-button :label="3">按月</el-radio-button>
                            <el-radio-button :label="4">按年</el-radio-button>
                            <el-radio-button :label="5">自定义</el-radio-button>
                        </el-radio-group>
                        <el-date-picker :picker-options="datePickerOption" class="filter-item" size="mini" v-if="listQuery.dateType == 1" :clearable="false" v-model="listQuery.searchDate" type="date" format="yyyy年MM月dd日" placeholder="选择日">
                        </el-date-picker>
                        <el-date-picker :picker-options="datePickerOption" class="filter-item" size="mini" v-if="listQuery.dateType == 2" :clearable="false" v-model="listQuery.searchDate" type="week" format="yyyy年WW周" placeholder="选择周">
                        </el-date-picker>
                        <el-date-picker :picker-options="datePickerOption" class="filter-item" size="mini" v-if="listQuery.dateType == 3" :clearable="false" v-model="listQuery.searchDate" type="month" format="yyyy年MM月" placeholder="选择月">
                        </el-date-picker>
                        <el-date-picker :picker-options="datePickerOption" class="filter-item" size="mini" v-if="listQuery.dateType == 4" :clearable="false" v-model="listQuery.searchDate" type="year" format="yyyy年" placeholder="选择年">
                        </el-date-picker>
                        <el-date-picker :picker-options="datePickerOption"  size="mini" v-if="listQuery.dateType == 5" :clearable="false" v-model="listQuery.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                        <el-button class="filter-item" size="mini" type="info" icon="el-icon-search" @click="doSearch">查看</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-refresh" @click="doReset">重置</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-download" @click="doExport">导出</el-button>
                    </div>

                    <el-table :data="list" stripe  id="table" v-loading="listLoading">
                        <el-table-column align="left" label="来源" min-width="120">
                            <template slot-scope="scope">
                                <span>{{scope.row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="count1" sortable label="建档" width="80">
                        </el-table-column>
                        <el-table-column prop="count2" sortable label="订车" width="80">
                        </el-table-column>
                        <el-table-column prop="count3" sortable label="交车" width="80">
                        </el-table-column>
                        <el-table-column prop="count4" sortable label="战败" width="80">
                        </el-table-column>
                        <el-table-column prop="count5" sortable label="休眠" width="80">
                        </el-table-column>
                        <el-table-column prop="count6" sortable label="N级" width="80">
                        </el-table-column>
                        <el-table-column prop="count7" sortable label="H级" width="80">
                        </el-table-column>
                        <el-table-column prop="count8" sortable label="A级" width="80">
                        </el-table-column>
                        <el-table-column prop="count9" sortable label="B级" width="80">
                        </el-table-column>
                        <el-table-column prop="count10" sortable label="C级" width="80">
                        </el-table-column>
                    </el-table>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { Chart } from "@antv/g2";
export default {
    data() {
        return {
            dealer: this.$common.getDealer(),
            list: null,
            listLoading: false,
            listQuery: {
                dateType: 1,
                searchDate: new Date(),
                dateRange: [new Date(), new Date()]
            },

            chart: {},
            chartLoading: false,
            chartData: [],

            datePickerOption: {
                firstDayOfWeek: 1,
            }
        };
    },
    mounted() {
        // this.renderChart();
        this.doSearch();
    },
    methods: {
        renderChart() {
            var chart = new Chart({
                container: 'chart',
                forceFit: true,
                height: 380
            });
            chart.source(this.chartData);
            chart.tooltip({
                crosshairs: {
                    type: 'line'
                }
            });
            chart.axis('count1', {
                label: {
                    formatter: function formatter(val) {
                        return val;
                    }
                }
            });
            chart.line().position('name*count1').color('column1').shape('smooth');
            chart.point().position('name*count1').color('column1').size(4).shape({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();

            this.chart = chart;
            this.retrieveChartData();
        },
        retrieveChartData() {
            var parent = this;
            parent.chartLoading = true;
            this.$httpAuth
                .post("/v1/reportRpc/taskChart", {
                    dealerId: this.dealer.dealerId,
                })
                .then(function (response) {
                    parent.chart.changeData(response.data.data);
                    parent.chartLoading = false;
                }).catch(() => {
                    parent.chartLoading = false;
                });
        },
        doSearch() {
            var startDate = '';
            var endDate = ''
            if (this.listQuery.dateType == 1) {
                startDate = this.listQuery.searchDate.Format("yyyy-MM-dd");
                endDate = startDate;
            }
            if (this.listQuery.dateType == 2) {
                startDate = this.$common.getFirstDayOfWeek(this.listQuery.searchDate);
                endDate = this.$common.getEndDayOfWeek(this.listQuery.searchDate);
            }
            if (this.listQuery.dateType == 3) {
                startDate = this.$common.getFirstDayOfMonth(this.listQuery.searchDate);
                endDate = this.$common.getEndDayOfMonth(this.listQuery.searchDate);
            }
            if (this.listQuery.dateType == 4) {
                startDate = this.$common.getFirstDayOfYear(this.listQuery.searchDate);
                endDate = this.$common.getEndDayOfYear(this.listQuery.searchDate);
            }
            if (this.listQuery.dateType == 5) {
                if (this.listQuery.dateRange.length != 2) {
                    this.$message({
                        message: '请选择时间范围',
                        type: 'warning'
                        });
                    return;
                }
                startDate = this.listQuery.dateRange[0].Format("yyyy-MM-dd");
                endDate = this.listQuery.dateRange[1].Format("yyyy-MM-dd");
            }
            var parent = this;
            parent.listLoading = true;
            this.$httpAuth
                .post("/v1/reportRpc/storeSourceSum", {
                    dealerId: this.dealer.dealerId,
                    dateStart: startDate,
                    dateEnd: endDate,
                })
                .then(function (response) {
                    var data = response.data.sums;
                    data.sort(function (a, b) {
                        var comparison = 0;
                        if (a.total > b.total) {
                            comparison = -1;
                        } else if (a.total < b.total) {
                            comparison = 1;
                        }
                        return comparison;
                    });
                    
                    parent.list = [...data,response.data.total];
                    parent.listLoading = false;
                }).catch(() => {
                    parent.listLoading = false;
                });
        },
        doReset() {
            this.list = null;
            this.listLoading = false;
            this.listQuery = {
                dateType: 1,
                searchDate: new Date(),
                dateRange: [new Date(), new Date()]
            };
            this.doSearch();
        },
        doExport() {
            console.log(document.getElementById("table").innerHTML);
            const loading = this.$loading({
                lock: true,
                text: '正在导出中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            // var parent = this;
            this.$httpAuth
                .post("/v1/reportRpc/exportExcel", {
                    html: document.getElementById("table").innerHTML,
                    name: "线下客户统计"
                })
                .then(function (response) {
                    console.log(response.data)
                    setTimeout(() => {
                        loading.close()
                        var a = document.createElement('a');
                        a.href = response.data.file;
                        a.click();
                    }, 1000);
                })
                .catch(() => {
                    loading.close()
                });
        }
    }
}
</script>

<style>

</style>
